import { useRepo } from '../useStore.js';
import { fmt, wc } from './util.js';

export default function Corkboard({ go, space, newDoc }) {
  const repo = useRepo();
  const docs = space ? space.docs : [];
  const isJournal = space?.id === 'journal';

  return (
    <div className="pane">
      <h2 className="pane-title">Corkboard</h2>
      <p className="pane-sub">One card per document. Jot a synopsis; click a title to open it.</p>
      <div className="card-grid">
        {docs.map(d => (
          <div className="card" key={d.id}>
            <div className="card-head">
              <button className="card-title" onClick={() => go({ docId: d.id, tool: 'write', mode: 'write' })}>
                {d.title || 'Untitled'}
              </button>
              <button
                className="icon-x" title="Delete" aria-label={'Delete ' + (d.title || 'Untitled')}
                onClick={() => repo.removeDocument(d.id)}
              >×</button>
            </div>
            <textarea
              className="card-syn" aria-label="Synopsis" placeholder="Synopsis…"
              value={d.synopsis}
              onChange={e => repo.patchDocument(d.id, { synopsis: e.target.value })}
            />
            <div className="card-foot">{fmt(wc(d.content))} words</div>
          </div>
        ))}
        <button className="card-add" onClick={newDoc}>+ {isJournal ? 'New entry' : 'New document'}</button>
      </div>
    </div>
  );
}
